import React from 'react';
import styled from 'styled-components';

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #64748b;
`;

const LoaderAnimation = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
  
  span {
    width: 8px;
    height: 8px;
    background: #275386;
    border-radius: 50%;
    animation: loading 1.4s infinite ease-in-out;
    
    &:nth-child(1) {
      animation-delay: 0s;
    }
    
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
  
  @keyframes loading {
    0%, 60%, 100% {
      transform: translateY(0);
      opacity: 0.5;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

const LoaderText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
`;

const HistoryLoader = () => {
  return (
    <LoaderContainer>
      <LoaderAnimation>
        <span></span>
        <span></span>
        <span></span>
      </LoaderAnimation>
      <LoaderText>Loading ...</LoaderText>
    </LoaderContainer>
  );
};

export default HistoryLoader; 